import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  bgHeader: {
    background:
      'transparent linear-gradient(75deg, #F77B1A 0%, #DE4C67 100%) 0% 0% no-repeat padding-box',
  },
  whiteColor: {
    color: theme.palette.common.white,

    '& h2': {
      paddingTop: theme.spacing(2),
      fontSize: 40,
    },
  },
  primaryColor: {
    color: '#7833FF',
  },
  graphiteColor: {
    color: theme.palette.grey[700],
  },
  plusInformation: {
    display: 'flex',
    gap: theme.spacing(0.4),
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(-1),
  },
  buttonWhite: {
    color: '#7833FF',
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(1.5, 3),
    borderRadius: 35,
    textTransform: 'none',

    '&:hover': {
      backgroundColor: theme.palette.grey[200],
    },
  },
  contentLeft: {
    marginLeft: theme.spacing(6),
  },
  contentRight: {
    paddingLeft: theme.spacing(9),
  },
  bgContainerSeason: {
    backgroundColor: theme.palette.grey[200],
  },
  negativeContainer: {
    position: 'relative',
    top: -50,
  },
  boxSeasonBreak: {
    backgroundColor: theme.palette.common.white,
    border: '1px solid #707070',
    borderRadius: 19,
    position: 'relative',
    boxShadow: '10px 10px 10px #00000029',
  },
  featuresBoxInformation: {
    position: 'relative',
    color: '#7833FF',

    '&::before': {
      display: 'block',
      position: 'absolute',
      top: 20,
      left: -40,
      content: '""',
      width: 30,
      height: 5,
      backgroundColor: '#7833FF',
    },
  },
  featureGrid: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'space-evenly',
      alignItems: 'flex-start',
    },
  },
  featureItem: {
    width: 300,
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: theme.spacing(4),
    marginLeft: 'auto',
    marginRight: 'auto',
    color: theme.palette.grey[700],

    '& img': {
      marginRight: theme.spacing(2),
    },

    [theme.breakpoints.up('sm')]: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  featuresBoxSubtitle: {
    marginTop: theme.spacing(2),
    color: theme.palette.grey[700],
  },
  featureItemAvatarCreation: {
    width: 300,
    display: 'grid',
    justifyItems: 'flex-start',
    marginTop: theme.spacing(4),
    marginLeft: 'auto',
    marginRight: 'auto',
    color: theme.palette.grey[700],

    '& img': {
      marginRight: theme.spacing(2),
    },

    [theme.breakpoints.up('sm')]: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  featuresBoxInformationWhite: {
    position: 'relative',
    color: theme.palette.common.white,

    '&::before': {
      display: 'block',
      position: 'absolute',
      top: 20,
      left: -40,
      content: '""',
      width: 30,
      height: 5,
      backgroundColor: theme.palette.common.white,
    },
  },
  featuresBoxSubtitleWhite: {
    marginTop: theme.spacing(2),
    color: theme.palette.common.white,
  },
}));
